webpackJsonp([35783957827783],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _skylineHome = __webpack_require__(894);
	
	var _skylineHome2 = _interopRequireDefault(_skylineHome);
	
	var _Splash = __webpack_require__(23);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  backgroundImage: 'url(' + _skylineHome2.default + ')'
	};
	
	var HomeSplash = function HomeSplash() {
	  return _react2.default.createElement(_Splash2.default, { style: style, title: 'Welcome to OLLIE' });
	};
	
	exports.default = HomeSplash;
	module.exports = exports['default'];

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/skyline-home.17c1d857.jpg";

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(13);
	
	var _HomeSplash = __webpack_require__(369);
	
	var _HomeSplash2 = _interopRequireDefault(_HomeSplash);
	
	var _FootnoteIcon = __webpack_require__(35);
	
	var _FootnoteIcon2 = _interopRequireDefault(_FootnoteIcon);
	
	var _FootnotesList = __webpack_require__(36);
	
	var _FootnotesList2 = _interopRequireDefault(_FootnotesList);
	
	var _ic_favorite_black_24px = __webpack_require__(900);
	
	var _ic_favorite_black_24px2 = _interopRequireDefault(_ic_favorite_black_24px);
	
	var _NBCLC_Logo = __webpack_require__(102);
	
	var _NBCLC_Logo2 = _interopRequireDefault(_NBCLC_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
		var footnotes = ["I'm a footnote!"];
	
		return _react2.default.createElement(
			'div',
			{ className: 'content' },
			_react2.default.createElement(_HomeSplash2.default, null),
			_react2.default.createElement(
				_reactMd.Card,
				{ className: 'md-block-centered main-content-card' },
				_react2.default.createElement(
					_reactMd.CardText,
					null,
					_react2.default.createElement(
						'h1',
						null,
						'OLLIE is your Online Legal Library and Information for Entrepreneurs.'
					),
					_react2.default.createElement(
						'p',
						null,
						'This site aims to guide you through the process of getting your business off the ground, legally, and to safely BECOME an entrepreneur. Walk through the BECOME modules\u2014business modeling, entity formation, capitalization, operational relationships, managing risks, and extra permits and licenses\u2014to get a sense of the kinds of situations that trigger red flags from a lawyer\'s point of view.'
					),
					_react2.default.createElement(
						'p',
						null,
						'Throughout these modules, you\'ll also see footnotes that offer more information. Click or tap on the icon to show the footnote: ',
						_react2.default.createElement(_FootnoteIcon2.default, { footnotes: footnotes, number: 1 })
					),
					_react2.default.createElement(
						_reactMd.Grid,
						null,
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Business Modeling'
							),
							_react2.default.createElement(
								'p',
								null,
								'Map out your business and pivot after getting feedback. Find out early, cheaply, and safely if your business needs to go in a different direction.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/business-modeling/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Entity Formation'
							),
							_react2.default.createElement(
								'p',
								null,
								'Learn about the legal nuances of forming an entity. Limited liability, tax treatment, decision-making, and capital ($$) are the main factors.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/entity-formation/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Capitalization'
							),
							_react2.default.createElement(
								'p',
								null,
								'Want to exchange a piece of your startup for money? Learn about the securities regulations involved, and what you\'ll see in convertible notes/term sheets.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/capitalization/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Operational Relationships'
							),
							_react2.default.createElement(
								'p',
								null,
								'Setting up your relationships with employees, independent contractors, and interns is difficult to get right. Learn all about the various categories here.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/operational-relationships/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Managing Risks'
							),
							_react2.default.createElement(
								'p',
								null,
								'Protect yourself and your business by securing your intellectual property. Learn more about trademark, copyright, and trade secret law.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/managing-risks/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 6 },
							_react2.default.createElement(
								'h2',
								null,
								'Extra Permits and Licenses'
							),
							_react2.default.createElement(
								'p',
								null,
								'Local county and city regulations may apply to your startup. Learn more about your local regulations in this module.'
							),
							_react2.default.createElement(
								_reactMd.Button,
								{ raised: true, href: '/extra-permits-and-licenses/' },
								'LEARN MORE'
							)
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 12 },
							_react2.default.createElement(
								'h3',
								null,
								'Footnotes'
							),
							_react2.default.createElement(_FootnotesList2.default, { footnotes: footnotes })
						),
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 2, style: { margin: 'auto', textAlign: 'center' } },
							_react2.default.createElement(
								'p',
								{ style: { fontSize: '16px' } },
								'Made with ',
								_react2.default.createElement('img', { className: 'svg-icon', src: _ic_favorite_black_24px2.default, alt: 'heart icon' }),
								' by:',
								' '
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'a',
									{ href: '/about-us' },
									_react2.default.createElement('img', {
										className: 'svg-icon'
										// style={{ width: '180px' }}
										, src: _NBCLC_Logo2.default,
										alt: 'New Business Community Law Clinic logo',
										style: { width: '200px', height: '100px' }
									})
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NBCLC_Logo.1236c4d5.svg";

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZDY2MDYwIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xMiAyMS4zNWwtMS40NS0xLjMyQzUuNCAxNS4zNiAyIDEyLjI4IDIgOC41IDIgNS40MiA0LjQyIDMgNy41IDNjMS43NCAwIDMuNDEuODEgNC41IDIuMDlDMTMuMDkgMy44MSAxNC43NiAzIDE2LjUgMyAxOS41OCAzIDIyIDUuNDIgMjIgOC41YzAgMy43OC0zLjQgNi44Ni04LjU1IDExLjU0TDEyIDIxLjM1eiIvPgo8L3N2Zz4="

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f1805e1660df4b7ade12.js